module.exports = __webpack_public_path__ + "static/media/DSCF0130-JzsoiYgs.69170115.JPG";